<template>
  <div class="imprint__main">
    <template v-for="text in section">
      <div class="imprint__section" :key="text.id">
        <div class="imprint__key">{{ changeLang(text.key) }}</div>
        <div class="imprint__value" v-html="text.value"></div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.imprint__main {
  width: 100%;
  background-color: #ffffff;
}

.imprint__main > div {
  padding: 20px;
  font-size: 12px;
}

.imprint__section {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #000000;
}

.imprint__section:first-child {
  border-top: 0;
}

.imprint__section > div {
  width: 50%;
}

.imprint__key {
  padding-right: 40px;
  text-transform: uppercase;
}

.imprint__key::after {
  content: ":";
}

@media screen and (max-width: 600px) {
  .imprint__section {
    flex-direction: column;
    width: 100%;
  }

  .imprint__section > div {
    width: 100%;
  }

  .imprint__key {
    padding-bottom: 20px;
    padding-right: 0;
  }
}
</style>

<script>
export default {
  name: "Intro",
  props: {
    section: Array
  },
  methods: {
    changeLang(data) {
      return this.$route.query.lang === "en" ? data.en : data.hu;
    }
  }
};
</script>
